import React from 'react';
import { Link } from "react-router-dom";
import TeamMember from './TeamMember';

const CenterContent = () => {
  return (
    <div id="ultra-premium-wellness">
      {/* Scoped CSS styling to prevent bleeding */}
      <style>
        {`
          #ultra-premium-wellness {
            /* Logo Theme Colors */
            --brand-pink: #ec1c74;
            --brand-blue: #00a8e8;
            --bg-color: #fbfcfd;
            --glass-bg: rgba(255, 255, 255, 0.7);
            --glass-border: rgba(255, 255, 255, 0.9);
            --text-main: #1d1d1f;
            --text-muted: #6e6e73;
            --accent-gradient: linear-gradient(135deg, var(--brand-blue), var(--brand-pink));
            
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            
            /* Subtle mesh gradient using logo colors */
            background: radial-gradient(circle at 0% 0%, rgba(0, 168, 232, 0.05) 0%, transparent 50%), 
                        radial-gradient(circle at 100% 100%, rgba(236, 28, 116, 0.05) 0%, transparent 50%);
            background-color: var(--bg-color);
            padding: 4rem 2rem;
            min-height: 100vh;
            border-radius: 40px;
            overflow: hidden;
            box-sizing: border-box;
          }

          #ultra-premium-wellness * {
            box-sizing: border-box;
          }

          #ultra-premium-wellness .glass-container {
            max-width: 1200px;
            margin: 0 auto;
            background: var(--glass-bg);
            backdrop-filter: blur(24px);
            -webkit-backdrop-filter: blur(24px);
            border: 1px solid var(--glass-border);
            border-radius: 32px;
            padding: 4rem 3rem;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.03), inset 0 1px 0 rgba(255, 255, 255, 1);
          }

          #ultra-premium-wellness .header-section {
            text-align: center;
            margin-bottom: 4rem;
          }

          #ultra-premium-wellness .content-title {
            font-size: 3.5rem;
            font-weight: 800;
            letter-spacing: -0.03em;
            color: var(--text-main);
            margin: 0 0 10px 0;
          }

          #ultra-premium-wellness .content-subtitle {
            font-size: 1.2rem;
            font-weight: 700;
            background: var(--accent-gradient);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            text-transform: uppercase;
            letter-spacing: 0.12em;
            margin-bottom: 20px;
            display: inline-block;
          }

          #ultra-premium-wellness .intro-text {
            font-size: 1.15rem;
            line-height: 1.7;
            color: var(--text-muted);
            max-width: 800px;
            margin: 0 auto;
          }

          #ultra-premium-wellness .section-heading {
            font-size: 2.2rem;
            font-weight: 700;
            color: var(--text-main);
            margin: 3rem 0 2rem 0;
            letter-spacing: -0.02em;
            text-align: center;
          }

          #ultra-premium-wellness .services-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
            gap: 1.8rem;
          }

          #ultra-premium-wellness .service-card {
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid var(--glass-border);
            border-radius: 24px;
            padding: 2.5rem 2rem;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.02);
            position: relative;
            overflow: hidden;
          }

          /* Top highlight line for cards using brand colors */
          #ultra-premium-wellness .service-card::before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0;
            height: 4px;
            background: var(--accent-gradient);
            opacity: 0;
            transition: opacity 0.4s ease;
          }

          #ultra-premium-wellness .service-card:hover {
            transform: translateY(-8px) scale(1.02);
            box-shadow: 0 20px 40px rgba(0, 168, 232, 0.08);
            border-color: rgba(0, 168, 232, 0.2);
            background: #ffffff;
          }

          #ultra-premium-wellness .service-card:hover::before {
            opacity: 1;
          }

          #ultra-premium-wellness .service-card h4 {
            font-size: 1.3rem;
            font-weight: 700;
            color: var(--text-main);
            margin: 0 0 12px 0;
            letter-spacing: -0.01em;
          }

          #ultra-premium-wellness .service-card p {
            font-size: 1.05rem;
            color: var(--text-muted);
            line-height: 1.6;
            margin: 0;
          }

          #ultra-premium-wellness .mission-box {
            background: linear-gradient(135deg, #1d1d1f, #2d2d30);
            border-radius: 28px;
            padding: 4rem 3rem;
            text-align: center;
            margin-top: 5rem;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            position: relative;
            border-top: 4px solid var(--brand-pink);
          }

          #ultra-premium-wellness .mission-box h3 {
            color: #ffffff;
            font-size: 2.2rem;
            font-weight: 700;
            margin: 0 0 15px 0;
          }

          #ultra-premium-wellness .mission-box p {
            color: rgba(255, 255, 255, 0.85);
            font-size: 1.25rem;
            line-height: 1.7;
            max-width: 800px;
            margin: 0 auto;
          }

          /* Responsive Tweaks */
          @media (max-width: 768px) {
            #ultra-premium-wellness { padding: 2rem 1rem; }
            #ultra-premium-wellness .glass-container { padding: 2rem 1.5rem; }
            #ultra-premium-wellness .content-title { font-size: 2.5rem; }
            #ultra-premium-wellness .mission-box { padding: 3rem 2rem; }
          }
        `}
      </style>

      <div className="glass-container">
        <div className="header-section">
          <h2 className="content-title">Maa Sadhana Foundation</h2>
          <p className="content-subtitle">Your Path to a New Life</p>
          <p className="intro-text">
            A Wellness Center is a place where individuals receive support to break free from addiction and embrace a healthy, substance-free life. At Maa Sadhana Foundation, we focus on the physical, mental, and emotional well-being of each person, offering a holistic approach to recovery.
          </p>
        </div>

        <h3 className="section-heading">Key Services at Our Wellness Center</h3>
        
        <div className="services-grid">
          {/* New Card 1 - Added at the top */}
          <div className="service-card">
            <h4>Holistic Health Assessment</h4>
            <p>A complete physical and psychological evaluation by our expert medical team to ensure a perfectly tailored and safe wellness journey.</p>
          </div>
          
          {/* New Card 2 - Added at the top */}
          <div className="service-card">
            <h4>24/7 Premium Care & Support</h4>
            <p>Round-the-clock dedicated support in a luxurious, serene environment, ensuring maximum comfort and immediate assistance at any hour.</p>
          </div>

          {/* Original 7 Cards */}
          <div className="service-card">
            <h4>Individual Assessment & Counseling</h4>
            <p>We begin by understanding each person’s history and health condition to create a personalized recovery plan tailored to each individual.</p>
          </div>
          <div className="service-card">
            <h4>Detoxification (Cleansing)</h4>
            <p>A medically supervised detox process cleanses the body of addictive substances, eliminating toxins and preparing for a fresh start.</p>
          </div>
          <div className="service-card">
            <h4>Psychological Counseling</h4>
            <p>Our trained counselors help build mental and emotional strength, instilling confidence, stability, and emotional balance.</p>
          </div>
          <div className="service-card">
            <h4>Yoga and Meditation Programs</h4>
            <p>Through yoga and mindfulness, we help individuals find inner peace, reduce anxiety, and build long-lasting resilience.</p>
          </div>
          <div className="service-card">
            <h4>Life Skills Training</h4>
            <p>We teach practical skills such as communication, stress management, and time management for a perfectly balanced life.</p>
          </div>
          <div className="service-card">
            <h4>Family Support and Counseling</h4>
            <p>Addiction affects the entire family. We offer comprehensive family counseling to foster a deeply supportive home environment.</p>
          </div>
          <div className="service-card">
            <h4>Follow-up Programs & Support</h4>
            <p>Regular follow-up sessions and dedicated support groups provide ongoing encouragement to maintain a successful recovery journey.</p>
          </div>
        </div>

        <div className="mission-box">
          <h3>Our Mission</h3>
          <p>
            We aim to help every individual build a new life—one that is healthy, fulfilling, and free from addiction, where they can achieve their dreams and bring happiness to their families.
          </p>
        </div>

        {/* <Link to="/" className="btn btn-warning ms-2 link-button">Know More / Our Inspiration</Link><br /> */}
        
        <div style={{ marginTop: '4rem' }}>
          <TeamMember />
        </div>
      </div>
    </div>
  );
};

export default CenterContent;